import i18n from "i18n";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { DataLakeBackends } from "@graylog/enterprise-api";
import { DATA_LAKE_BACKEND_QUERY_KEYS } from "data-lake/Constants";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = [];
const refetchInterval = 5e3;
const fetchConfig = () => DataLakeBackends.getAll();
const useDataLakeBackends = ({ enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: [...DATA_LAKE_BACKEND_QUERY_KEYS],
    queryFn: () => defaultOnError(
      fetchConfig(),
      i18n.t("notifications.fetch_backends_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_backends_failed_title", { ns: "enterprise_data_lake" })
    ),
    placeholderData: keepPreviousData,
    refetchInterval,
    notifyOnChangeProps: ["data", "error"],
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading
  };
};
export default useDataLakeBackends;
